module.exports = __webpack_public_path__ + "static/media/formSearchButton.011296c3.png";